/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable sonarjs/no-collection-size-mischeck */

import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { IonPopover, ModalController } from '@ionic/angular/standalone'
import { Observable, of, Subject } from 'rxjs'
import { catchError, debounceTime, distinctUntilChanged, filter, switchMap, tap } from 'rxjs/operators'
import { IOrgFilter, Org } from '../models/org.model'
import { ApiService } from '../services/api/api.service'
import { CacheService } from '../services/business/cache.service'
import { PlatformService } from '../services/business/platform.service'
import { MyProfileComponent } from './my-profile/my-profile.component'
import { AuthWrapperService } from '../../../src/security/models/services/auth'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  isProfileOpen = false
  @Output() profileUpdate: EventEmitter<boolean> = new EventEmitter<boolean>()
  @ViewChild('profilePopover') profilePopover: IonPopover

  orgs$: Observable<Org[]>
  orgTermInput$ = new Subject<string>()
  orgLoading = false
  selectecOrg: Org
  isInternalUser = false

  constructor(
    public authWrapperService: AuthWrapperService,
    public platform: PlatformService,
    public modalController: ModalController,
    public cacheService: CacheService,
    public apiService: ApiService,
    public titleService: Title
  ) {
  }

  ngOnInit(): void {
    void this.loadCurrentOrg()
    this.setupOrgSelectorAutocomplete()
  }

  async loadCurrentOrg(): Promise<void> {
    this.isInternalUser = this.authWrapperService.isInternalUser()
    if (this.isInternalUser) {
      const org = await this.cacheService.getOrg()
      this.selectecOrg = org
    }
  }

  setupOrgSelectorAutocomplete(): void {
    this.orgs$ = this.orgTermInput$.pipe(
      filter(res => {
        return res !== null && res.length >= 0 //minlegth
      }),
      distinctUntilChanged(),
      debounceTime(500),
      tap(() => this.orgLoading = true),
      switchMap(term => {
        const payload: IOrgFilter = {
          paging: {
            pageIndex: 0,
            pageSize: 20,
          },
          filter: {
            name: term,
            description: null,
            programGroupIds: null,
            stakeholderId: null,
            type: null,
            programGroup: null
          },
          sort: {
            column: 'name',
            direction: 'asc'
          }
        }
        return this.apiService.searchOrgs(payload).pipe(
          catchError(() => of([])), // empty list on error
          tap(() => this.orgLoading = false)
        )
      })
    )
  }

  orgChanged(org: Org): void {
    if (org && org.rId) {
      this.cacheService.setOrg(org)
      this.authWrapperService.setSimulatedOrgId(org?.rId)
      this.cacheService.internalUserOrgChanged.next(true)
    }
  }

  logout(): void {
    void this.cacheService.clearCache()
    void this.authWrapperService.logOut()
  }

  public toggleProfile(showMenu = false, event: MouseEvent = null): void {
    if (this.platform.isDesktop()) {
      this.isProfileOpen = showMenu
      if (event) {
        this.openPopover(this.profilePopover, event)
      }
      if (!showMenu) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.profilePopover.dismiss()
      }
    }
  }

  private openPopover(popover: IonPopover, event: MouseEvent): void {
    const rect: DOMRect = (event.target as HTMLElement).getBoundingClientRect()

    const newEvent = new MouseEvent('newMouseEvent', {
      ...event,

      clientX: rect.left,

      clientY: rect.top + rect.height,
    })
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    popover.present(newEvent)
  }

  public async viewProfile(): Promise<void> {
    const eventEmitter = new EventEmitter<boolean>()
    eventEmitter.subscribe(res => {
      this.profileUpdate.emit(res)
    })

    await this.profilePopover.dismiss()
    const modal = await this.modalController.create({
      component: MyProfileComponent,
      cssClass: this.platform.isDesktop() ? 'my-profile-modal' : '',
      componentProps: {
        profileUpdate: eventEmitter,
        callerTitle: this.titleService.getTitle()
      }
    })
    return modal.present()
  }
}
